export const isNullOrWhiteSpace = (
    value: string | number | undefined | null
): boolean => {
    return !(value || '').toString().trim().length;
};

export const getYouTubeVideoKey = (value: string): string => {
    const regex = new RegExp(
        '^(?:https?:)?//[^/]*(?:youtube(?:-nocookie)?.com|youtu.be).*[=/]([-\\w]{11})(?:\\?|=|&|$)'
    );

    if (isNullOrWhiteSpace(value)) {
        return '';
    }

    const matches = value.match(regex);

    return (matches || []).length > 1 ? matches[1] : '';
};

export const removeTrailingSlash = (url: string): string => {
    return url.replace(/\/+$/, '');
};

export const addTrailingSlash = (url: string): string => {
    return url.replace(/\/?$/, '/');
};

export const isValidUrl = (userInput: string): boolean => {
    return (
        userInput.match(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&=]*)/g
        ) !== null
    );
};
